import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Filter from '../layout/Filter';
import { Link, useLocation } from "react-router-dom";
import "./Package.css";  
import SearchIcon from '@mui/icons-material/Search';
import PakagesData from '../layout/PakagesData';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';

export default function Package() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const q = params.get("search");
    if (q) {
      setSearchQuery(q);
      setSearchInput(q);
    }
  }, [location.search]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setSearchQuery(searchInput);
  };

  const filteredPackages = PakagesData.filter((pkg) => {
    if (!searchQuery.trim()) return true;
    const q = searchQuery.toLowerCase();
    return (
      (pkg.pakagename && pkg.pakagename.toLowerCase().includes(q)) ||
      (pkg.nummbertest && pkg.nummbertest.toLowerCase().includes(q))
    );
  });

  return (
    <>
    <Header/>

    <div className="test_bredcum_sec">
        <div className="container-fluid">
            <div className="test_bredcum">
               <Link to="/">Home</Link>
                <span>&gt;</span>
                <span className='name_p'>All Packages</span>
            </div> 
        </div> 
    </div>
    
    <div className="labtest_main_page">
        <div className="container-fluid">
            <div className="inner_labtest">
                <div className="row">
                    <div className="col-xl-3 col-lg-4">
                        <Filter open={open} setOpen={setOpen} />  
                    </div>
                    <div className="col-xl-9 col-lg-8">
                        <div className="right_side_header_test">
                            <h3>Popular Health Checkup Packages ({filteredPackages.length})</h3>
                            
                            <div className="search_bar_test">
                                <div className="main_serach_bar_test">
                                    <form className="search-form_test" onSubmit={handleSearchSubmit}>
                                        <input 
                                          type="search" 
                                          placeholder="Search Packages.........." 
                                          className="search_input" 
                                          value={searchInput}
                                          onChange={(e) => setSearchInput(e.target.value)}
                                        />
                                        <button type="submit" className="search_btn"> <SearchIcon /> </button>
                                    </form>
                                </div>
                                <div className="filter_btn">
                                    <button className="filter_btn" onClick={() => setOpen(true)} >
                                        <TuneRoundedIcon/>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="pakages_boxes_section">
                            <div className="row">
                                {filteredPackages.length === 0 ? (
                                  <div className="col-12 py-5 text-center">
                                    <h4>No packages found matching "{searchQuery}"</h4>
                                    <button className="btn btn-outline-secondary mt-2" onClick={() => { setSearchQuery(""); setSearchInput(""); }}>Reset Search</button>
                                  </div>
                                ) : (
                                  filteredPackages.map((pakage) => (
                                      <div className="col-xl-4 col-lg-6 col-md-6 col-12" key={pakage.id} >
                                          <div className="pakages_main_box">
                                              <img src={pakage.image} alt={pakage.pakagename} />
                                              <div className="content_pakages">
                                                  <div className="content_pakages_uper">
                                                      <h4>{pakage.pakagename}</h4>
                                                      <p>{pakage.age}</p>
                                                      <div className="price_and_offer">
                                                          <h5>{pakage.prices} <span className='off_price_pakages'>{pakage.cutprices}</span></h5>
                                                          <span className='offer_pakages'>{pakage.offer}</span>
                                                      </div>
                                                  </div>
                                                  <div className="content_pakages_lower">
                                                      <p>{pakage.nummbertest}</p>
                                                      <div className="package_box_btns">
                                                          <div className="package_detail_right_btn pf_btn-n">
                                                              <Link to="/packagedetail">   
                                                                  {pakage.btnfirst}
                                                              </Link>
                                                          </div>
                                                          <div className="package_detail_right_btn puf_btn-n">
                                                              <a href="#">{pakage.btnsecond}</a>
                                                          </div>
                                                      </div>
                                                  </div> 
                                              </div> 
                                          </div>
                                      </div>
                                  ))
                                )} 
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <Footer/>
    </>
  )
}
